import i18n from "@/i18n.js";

export default [{ id: "li_d_nummer", name: i18n.t("integrations.company.attribute.li_d_nummer") }];
